import { Injectable } from '@angular/core';
import { Site, SiteRequest, SiteUpdateRequest } from '../modules/crm/site/components/site-list/site-list.interface';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  private readonly urlBase = environment.baseURL;
  private readonly urlSite = `${this.urlBase}/site`;
  private readonly urlSiteTemplate = `${this.urlSite}/templates`;
  private readonly urlSiteSettings = `${this.urlSite}/settings`;

  constructor(private readonly http: HttpClient) {}

  public getSites() {
    return this.http.get<any>(this.urlSite)
      .pipe(map(v => v.data));
  }

  public getSite(id: string) {
    return this.http.get<any>(`${this.urlSite}/${id}`)
      .pipe(map(v => v.data));
  }

  public createSite(site: SiteRequest) {
    return this.http.post<any>(this.urlSite, site)
      .pipe(map(v => v.data));
  }

  public updateSite(id: string, site: SiteUpdateRequest) {
    return this.http.put<any>(`${this.urlSite}/${id}`, site)
      .pipe(map(v => v.data));
  }

  public deleteSite(id: string) {
    return this.http.delete<any>(`${this.urlSite}/${id}`)
      .pipe(map(v => v.data));
  }

  public loadSettings(id: string) {
    return this.http.get<any>(`${this.urlSiteSettings}/${id}`)
      .pipe(map(v => v.data));
  }

  public saveSettings(id: string, settings: any) {
    return this.http.put<any>(`${this.urlSiteSettings}/${id}`, settings)
      .pipe(map(v => v.data));
  }

  public uploadFiles(files: File[]) {
    const formData: FormData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    return this.http.post<any>(`${this.urlSite}/assets`, formData);
  }

  public uploadSite(id: string, file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(`${this.urlSite}/upload-site/${id}`, formData)
      .pipe(map(v => v.data));
  }
}
